import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

const useTarifas = () => {
  const [tarifas, setTarifas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [busqueda, setBusqueda] = useState("");

  const fetchTarifas = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(API_ENDPOINTS.interna.SelectAllDataTarifa);
      if (!res.ok) throw new Error("Error al obtener datos del servidor");
      const data = await res.json();
      setTarifas(data);
    } catch (err) {
      console.error("Error al cargar Tarifas:", err);
      setError("No se pudieron cargar los Tarifas.");
    } finally {
      setLoading(false);
    }
  };

  const filtrarTarifas = () => {
    const q = busqueda.toLowerCase();
    return tarifas.filter((tarifa) => tarifa.tipo_movil?.toLowerCase().includes(q) || tarifa.tag_rate?.toLowerCase().includes(q) || (tarifa.estado === 1 ? "activo" : "inactivo").includes(q));
  };

  useEffect(() => {
    fetchTarifas();
  }, []);

  return {
    tarifas,
    loading,
    error,
    busqueda,
    setBusqueda,
    filtrarTarifas,
    fetchTarifas,
  };
};

export default useTarifas;
